import { useEffect } from 'react'
import { reportClientError } from 'services/errorReportingService'

const highValueUTMParams = ['gclid', 'fbclid', 'irclickid', 'utm_brz_id']

type ReportErrorType = 'PageRoutes' | 'ContentfulWebPage' | 'GoogleHotelAdPage' | 'OfferPage' | 'BedbankOfferPage' | 'DestinationProductPage'

export type ReportErrorProps = {
  type: ReportErrorType
  meta?: any
  sampleRatePercent?: number
}

/** We only reporting a sub-set of errors here to reduce the total number of logs reported to sentry (and avoid reporting volume limits) */
const use404Logger = (reportError?:ReportErrorProps) => {
  useEffect(() => {
    const getHighValueUTMParams = ():Array<string> => {
      const urlParams = new URLSearchParams(window.location.search)
      return highValueUTMParams.filter(param => urlParams.has(param))
    }

    if (reportError) {
      const highValueItemParams = getHighValueUTMParams()

      const reportMeta = {
        meta: reportError.meta,
        type: reportError.type,
        sampleRatePercent: reportError.sampleRatePercent,
        highValueItemParams,
      }
      if (reportError.sampleRatePercent && Math.random() * 100 > reportError.sampleRatePercent) {
        console.warn('Paid Marketing 404 - Request with UTM params Resulted in 404 (sample rate not met)', reportMeta)
        return
      }
      if (highValueItemParams.length > 0) {
        reportClientError(new Error('Paid Marketing 404 - Request with UTM params Resulted in 404'), reportMeta)
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}

export {
  use404Logger,
}
